class MobileNav {
  constructor(dom) {
    this.NAME = 'MobileNav';
    this.dom = dom;
    this.toggleButton = dom.querySelector('[data-mobile-nav-toggle-button]');
    this.panel = dom.querySelector('.mobile-nav');
    this.dropdownToggle = dom.querySelector('[data-mobile-nav-toggle]');
    this.dropdown = dom.querySelector('[data-mobile-nav-dropdown]');
    this.dropdownClose = dom.querySelector('[data-mobile-nav-close]');
    this.panelClose = dom.querySelector('[data-mobile-nav-panel-close]');
  }

  init() {
    if (!this.toggleButton || !this.panel) return;

    this.toggleButton.addEventListener('click', () => {
      if (this.panel.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    });

    if (this.dropdownToggle) {
      this.dropdownToggle.addEventListener('click', (event) => {
        event.preventDefault();
        this.openDropdown();
      });
    }

    if (this.dropdownClose) {
      this.dropdownClose.addEventListener('click', () => this.close());
    }

    if (this.panelClose) {
      this.panelClose.addEventListener('click', () => this.close());
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  open() {
    this.panel.classList.add('is-open');
    this.toggleButton.classList.add('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-nav-open');
  }

  close() {
    this.panel.classList.remove('is-open');
    this.toggleButton.classList.remove('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-nav-open');
    this.closeDropdown();
  }

  openDropdown() {
    if (!this.dropdown) return;
    this.dropdown.classList.add('is-open');
    this.dropdownToggle.setAttribute('aria-expanded', 'true');
  }

  closeDropdown() {
    if (!this.dropdown) return;
    this.dropdown.classList.remove('is-open');
    this.dropdownToggle.setAttribute('aria-expanded', 'false');
  }
}

export default MobileNav;
